var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.99219L9.00781 8V8.49219H0.992188V8L2 6.99219V4.50781C2 3.72656 2.19531 3.04688 2.58594 2.46875C2.99219 1.89062 3.54688 1.51562 4.25 1.34375V0.992188C4.25 0.789062 4.32031 0.617188 4.46094 0.476562C4.60156 0.320312 4.78125 0.242188 5 0.242188C5.21875 0.242188 5.39844 0.320312 5.53906 0.476562C5.67969 0.617188 5.75 0.789062 5.75 0.992188V1.34375C6.45312 1.51562 7 1.89062 7.39062 2.46875C7.79688 3.04688 8 3.72656 8 4.50781V6.99219ZM5 9.99219C4.71875 9.99219 4.47656 9.89844 4.27344 9.71094C4.08594 9.52344 3.99219 9.28906 3.99219 9.00781H6.00781C6.00781 9.27344 5.90625 9.50781 5.70312 9.71094C5.5 9.89844 5.26562 9.99219 5 9.99219Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBell);
export default __webpack_public_path__ + "static/media/icn-bell.a4c12afc.svg";
export { ForwardRef as ReactComponent };